const StorageService = {
  cookieDomain: import.meta.env.VITE_COI_COOKIE_DOMAIN,

  removeItem: (key: string) => {
    if (window.location.hostname.includes("cookieinformation.com")) {
      document.cookie = `${key}=; path=/; domain=.cookieinformation.com; expires=Thu, 01 Jan 1970 00:00:01 GMT; secure`;
    } else {
      document.cookie = `${key}=; path=/; domain=${StorageService.cookieDomain}; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }
  },
  setItem: (key: string, value: string) => {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 1);

    if (window.location.hostname.includes("cookieinformation.com")) {
      document.cookie = `${key}=${value}; domain=.cookieinformation.com; expires=${date.toUTCString()}; path=/; SameSite=Lax; secure`;
    } else {
      document.cookie = `${key}=${value}; domain=${StorageService.cookieDomain}; expires=${date.toUTCString()}`;
    }
  },
  getItem: (key: string) => {
    const cookies = document.cookie.split(";").reduce<{ [key: string]: string }>((acc, item) => {
      const [name, value] = item.split("=");
      acc[name.trim()] = value;
      return acc;
    }, {});
    return cookies[key];
  },
};

export default StorageService;
